import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HorribleHerosXSymbol} from "../../symbols/HorribleHerosXSymbol";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class HorribleHeroesSpinReelPartAnimator extends SpinReelPartAnimator {
    private visibleIndexes: number[] = [1, 2, 3, 4];
    private _reelSize: number = 4;

    public setReelSize(reelSize: number) {
        this._reelSize = reelSize;
    }

    public resetReelSize(symHeight: number): void {
        this.symHeight = symHeight;
        //#377
    }

    public resetSize(symHeight: number, updateSymbols: boolean, positionStopId: number, mSymbolSize: number): void {
        this.symHeight = symHeight;
        this.initTargetPositions();
        this.visibleIndexes = [];
        if (updateSymbols) {
            this.initSymbolsPosition();
            if (this._reelSize) {
                for (let j = 1; j <= this._reelSize; j++) {
                    this.visibleIndexes.push(j);
                }
            }
            for (let i: number = 0; i < this.symbolsToAnimate.length; i++) {
                const symName: string[] = this.symbolsToAnimate[i].symName.split("_");
                if (this.visibleIndexes.indexOf(i) !== -1) {
                    if (this.symbolsToAnimate[i]!.symName.split("_")[1]) {
                        const stackIndex: string = symName[1].split("*")[1];
                        const stackSize: string = symName[1].split("*")[0];
                        if (stackSize == "2") {
                            this.symbolsToAnimate[i].y = ((i - parseInt(stackIndex)) * symHeight);
                        } else {
                            this.symbolsToAnimate[i].y = ((i - parseInt(stackIndex)) * symHeight) + (symHeight / 2);
                        }
                    } else {
                        //for all other symbols
                        this.symbolsToAnimate[i].visible = true;
                        this.symbolsToAnimate[i].y = ((i - 1) * symHeight) + (symHeight / 2);
                    }
                } else {/*for top symbol at i==0*/
                    this.symbolsToAnimate[i].y = ((i - 1) * symHeight) + (symHeight / 2);
                    this.symbolsToAnimate[i].visible = false;
                }

                const stackSize: number = symName.length > 1 ? parseInt(symName[1][0]) : 1;
                if (this.symbolsToAnimate[i].symName.length > 1 && this.symbolsToAnimate[i].symName[0] == "X") {
                    if (Reels.getSymbol(this._reelId, positionStopId)!.symName.indexOf("X") !== -1) {
                        (<HorribleHerosXSymbol>Reels.getSymbol(this._reelId, positionStopId)).patchMultiplier(parseInt(this.symbolsToAnimate[i].symName[2]));
                    }
                }

                this.symbolsToAnimate[i].symHeight = symHeight * stackSize;
                //#377 whiteframe and blank space
            }
        }
    }

    //#569OverRidden for fast spin to reduce time before first reelStop
    public getStopTime(stopSteps: number, nearWin: boolean): number {
        if (GameSetting.isFastSpin) {
            return (this.spinSpeed * stopSteps) - 0.1;
        } else {
            return super.getStopTime(stopSteps, nearWin);
        }
    }

    /**
     * @inheritDoc
     */
    protected fadeOutSymbolBlur(): void {
        super.fadeOutSymbolBlur();

        this.initTargetPositions();
        //#377
    }

    protected resetSymbolsPosition(): void {
        for (let i: number = 1; i < this._symbolsToAnimate.length; i++) {
            this._targetPositions[i] = this._symbolsToAnimate[i].y;
        }

        //fix for #13
        super.resetSymbolsPosition();
    }

    /*OverRiding bounce duration to sync up with X landing*/
    /*inspired  from east ws west */

    //#226  resizing all symbols all together
}